import { IWobGliderBaseConstParam, WobGliderBase } from '@/models/wob//WobGliderBase'
import { ISmartResult,getDefaultSmartResult } from '../iris/smartMission/ISmartResult'

export interface IWobSimProgressConstParam extends IWobGliderBaseConstParam {  
  irisRawResult: string
  simulationState:string
  simulationName	:string
  simulationCompany :string
  simulationIteration	:number
}

export class WobSimProgress extends WobGliderBase {  
  public irisRawResult: string
  public simulationState : string
  public irisResult: ISmartResult
  simulationName	:string
  simulationCompany :string
  simulationIteration	:number
  

  constructor({ irisRawResult,simulationState,simulationName,simulationCompany,simulationIteration, ...args }: IWobSimProgressConstParam) {
    super(args)
    this.irisRawResult = irisRawResult
    this.simulationState = simulationState        
    this.simulationIteration = simulationIteration
    this.simulationName = simulationName
    this.simulationCompany = simulationCompany
    this.irisResult = (irisRawResult?.length ?? 0 )>0?{...getDefaultSmartResult(),...JSON.parse(irisRawResult)}:null    
  }
}
